import React from "react";
import ServiceHero from "./sections/ServiceHero/ServiceHero";
import ServiceContent from "./sections/ServiceContent/ServiceContent";

const Services = () => {
  return (
    <div>
      <ServiceHero />
      <ServiceContent />
    </div>
  );
};

export default Services;
